import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAdminAuth } from './AdminAuthContext';
import './Admin.css';

const NAV = [
  { path: '/admin',           label: 'Dashboard', icon: '📊', exact: true },
  { path: '/admin/articles',  label: 'Articles',  icon: '📝' },
  { path: '/admin/widgets',    label: 'Widgets',    icon: '🧩' },
  { path: '/admin/discussion',   label: 'Discussion',   icon: '💬' },
  { path: '/admin/block-styles', label: 'Block Styles', icon: '🎨' },
  { path: '/admin/footer',       label: 'Footer',       icon: '🔻' },
  { path: '/admin/media',      label: 'Media',      icon: '🖼️' },
  { path: '/admin/users',     label: 'Users',     icon: '👥', adminOnly: true },
  { path: '/admin/categories',label: 'Categories',icon: '🏷️', adminOnly: true },
  { path: '/admin/menu',      label: 'Nav Menu',  icon: '🗂️' },
];

export default function AdminLayout({ children }) {
  const { user, logout } = useAdminAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const [collapsed, setCollapsed] = useState(false);

  const handleLogout = () => { logout(); navigate('/admin/login'); };

  const isActive = (nav) => nav.exact
    ? location.pathname === nav.path
    : location.pathname.startsWith(nav.path);

  const visibleNav = NAV.filter(n => !n.adminOnly || user?.role === 'admin');

  return (
    <div className={`admin-shell ${collapsed ? 'collapsed' : ''}`}>
      {/* Sidebar */}
      <aside className="admin-sidebar">
        <div className="admin-sidebar-header">
          <Link to="/" className="admin-logo">
            <span className="admin-logo-icon">🗞️</span>
            {!collapsed && <span className="admin-logo-text">RIN-NodeJS</span>}
          </Link>
          <button className="admin-collapse-btn" onClick={() => setCollapsed(!collapsed)}>
            {collapsed ? '→' : '←'}
          </button>
        </div>

        <nav className="admin-nav">
          {visibleNav.map(item => (
            <Link
              key={item.path}
              to={item.path}
              className={`admin-nav-item ${isActive(item) ? 'active' : ''}`}
            >
              <span className="admin-nav-icon">{item.icon}</span>
              {!collapsed && <span className="admin-nav-label">{item.label}</span>}
            </Link>
          ))}
        </nav>

        <div className="admin-sidebar-footer">
          <div className="admin-user-info">
            <div className="admin-user-avatar">{user?.avatar || '?'}</div>
            {!collapsed && (
              <div className="admin-user-details">
                <div className="admin-user-name">{user?.name}</div>
                <div className={`admin-role-badge role-${user?.role}`}>{user?.role}</div>
              </div>
            )}
          </div>
          <button className="admin-logout-btn" onClick={handleLogout} title="Logout">
            {collapsed ? '🚪' : '🚪 Logout'}
          </button>
        </div>
      </aside>

      {/* Main content */}
      <main className="admin-main">
        <div className="admin-content">
          {children}
        </div>
      </main>
    </div>
  );
}
